import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data } from "../../../utils/common";

export const AllManageReports = createAsyncThunk(
  "admin/manage-wallet/get-all-manage-reports",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.ManageReport.getAllManageReports}?name=${filter?.name ||
          ""}&from=${filter?.from}&to=${filter?.to}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllManageReportsById = createAsyncThunk(
  "admin/manage-wallet/get-all-manage-reports-by-id",
  async ({ id }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.ManageReport.getAllManageReports}/${id}`);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "manage-reports",
  initialState: {
    all_reports: {},
    all_reports_by_id: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete

      .addCase(AllManageReports.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllManageReports.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        state.all_reports = action.payload || {};
      })
      .addCase(AllManageReports.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;

        state.error = action.payload;
      })

      .addCase(AllManageReportsById.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllManageReportsById.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        state.all_reports_by_id = action.payload || {};
      })
      .addCase(AllManageReportsById.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;

        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
